import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../api";
import {AdminGame, DashboardStatistics, DataParams, LogEvent, NavigationParams, Session} from "../../types/admin";

export type AdminDashboardState = {
    loaded: boolean
    error: string | null
    statistics: DashboardStatistics | null
    game_sessions: Session[]
    events: LogEvent[]
    most_popular_games: AdminGame[]
    date_start: string
    date_end: string
    date_range: string
}

const initialState: AdminDashboardState = {
    loaded: false,
    error: null,
    statistics: null,
    game_sessions: [],
    events: [],
    most_popular_games: [],
    date_start: '',
    date_end: '',
    date_range: '30'
}

const extractParams = (params: DataParams): NavigationParams => {
    let _params: any = {};
    if (params.date_start) _params.date_start = params.date_start;
    if (params.date_end) _params.date_end = params.date_end;
    return _params;
}

export const getAdminDashboard = createAsyncThunk(
    'adminDashboard/getAdminDashboard',
    async (params: DataParams, thunkAPI) => {
        const _params = extractParams(params);
        try {
            return await api.get('/API/admin/', _params);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: 'adminDashboard',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminDashboard.pending, (state) => {
                state.loaded = false;
                state.error = null;
            })
            .addCase(getAdminDashboard.fulfilled, (state, action) => {
                state.loaded = true;
                state.error = null;
                state.statistics = action.payload.statistics;
                state.game_sessions = action.payload.game_sessions;
                state.events = action.payload.events;
                state.most_popular_games = action.payload.most_popular_games;
                state.date_start = action.payload.date_start;
                state.date_end = action.payload.date_end;
                state.date_range = String(action.payload.date_range);
            })
            .addCase(getAdminDashboard.rejected, (state, action) => {
                state.loaded = true;
                if (typeof action.payload === 'string') {
                    state.error = action.payload as string;
                } else if (typeof action.error?.message === 'string') {
                    state.error = action.error.message;
                }
            });
    }
});

export const {clearError} = slice.actions;
export default slice.reducer;